import { t } from '@lingui/macro';

import {
  DISPLAY_NAME_FOR_SERVICE_LANDING_ENUM,
  ServiceLandingEnum,
} from '@rover/types/src/ServiceLanding';

// The order of services here determines the order they show in the nav
export const NAVBAR_SERVICE_OPTIONS = [
  ServiceLandingEnum.DOG_BOARDING,
  ServiceLandingEnum.HOUSE_SITTING,
  ServiceLandingEnum.PET_SITTING,
  ServiceLandingEnum.DOGGY_DAY_CARE,
  ServiceLandingEnum.DOG_WALKING,
  ServiceLandingEnum.DOG_TRAINING,
];

export const getServiceLinkDisplayName = (
  serviceLandingType,
  shouldShowTrainingService = false
) => {
  switch (serviceLandingType) {
    case ServiceLandingEnum.DOG_TRAINING:
      return shouldShowTrainingService
        ? DISPLAY_NAME_FOR_SERVICE_LANDING_ENUM()[serviceLandingType]
        : t`Dog Training with GoodPup`;
    case ServiceLandingEnum.PET_SITTING:
      return t`Drop-In Visits`;
    default:
      return DISPLAY_NAME_FOR_SERVICE_LANDING_ENUM()[serviceLandingType];
  }
};
